<template>
  <div class="not-found">
    <h1 class="heading">404 - Page Not Found</h1>
    <p class="paragraph">Sorry, the page you're looking for doesn't exist.</p>
    <b-button variant="cta" size="lg" @click="goHome" class="go-home-btn"
      >Go to Home</b-button
    >
  </div>
</template>

<script>
export default {
  name: "NotFound",
  methods: {
    goHome() {
      this.$router.push("/");
    }
  }
};
</script>

<style scoped>
.not-found {
  text-align: center;
  padding: 50px;
}

.heading {
  font-family: "PlusJakartaSansBold";
  font-size: 2rem;
  color: #1e1e22;
  margin: 0 auto 20px;
}

.paragraph {
  font-size: 1.6rem;
  color: #1e1e22;
  text-align: center;
  margin: 0 auto 20px;
}

.go-home-btn {
  padding: 10px 20px;
  background-color: #42b983;
  color: white;
  border: none;
  cursor: pointer;
  font-size: 16px;
}

.go-home-btn:hover {
  background-color: #35495e;
}
</style>
